import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { Language, languageService } from '../services/languageService';
import { getTranslation } from '../translations';
import { TranslationKeys } from '../translations/en';

interface LanguageContextType {
  language: Language;
  t: TranslationKeys;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(languageService.getCurrentLanguage());
  const [t, setT] = useState<TranslationKeys>(getTranslation(language));

  useEffect(() => {
    setT(getTranslation(language));
  }, [language]);

  const setLanguage = (lang: Language) => {
    languageService.setLanguage(lang);
    setLanguageState(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, t, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

